import React, { useEffect, useCallback } from 'react'
import { Route, Routes, useNavigate, useSearchParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUserInfo } from '../../Api/user'
import { loadUserRequest } from '../../Actions/user'
import Tasks from '../Tasks/Tasks'
import Auth from '../Auth/Auth'
import Ask from '../Ask/Ask'
import Transcript from '../Transcript/Transcript'
import Summary from '../Transcript/Summary'
import Welcome from '../Welcome/Welcome'
import Login from '../Auth/Login'
import LoginAgain from '../Auth/LoginAgain'
import LoginSuccess from '../Auth/LoginSuccess'
import Home from '../Home/Home'
import ReConfirm from '../ReConfirm/ReConfirm'
import GoogleCallback from '../Auth/GoogleCallback'
import FunctionalDashboard from '../FunctionDashboard/FunctionDashboard'
import { toast } from 'react-toastify'
import Function from '../Functions/Function'
import NavbarLayout from '../Layouts/NavbarLayout'
import Meeting from '../Meetings2/Meetings'
import { useContext } from 'react'
import { GetStartedContext } from '../../Context/GetStartedContext'
import GetStarted from '../GetStartedChecklist/GetStarted'
import ZoomLogin from '../ZoomScreen/ZoomLogin'
import ZoomDisconnectScreen from '../ZoomScreen/ZoomDisconnectScreen'
import VCComments from '../VCComments'
import CompanyDashboard from '../CompanyDashboard'

const AllRoutes = ({ loadUser, user }) => {
  const [searchParams, SetSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const fetchUserData = useCallback(
    async (isLogin) => {
      const apiResponse = await getUserInfo()
      if (apiResponse) {
        loadUser(apiResponse)
        if (isLogin) {
          apiResponse.role === null
            ? navigate('/choose-function')
            : navigate('/signin-success')
        }
      } else{
        localStorage.removeItem('token')
        navigate('/')
      }
    },
    [loadUser, navigate]
  )
  
  useEffect(() => {
    if (localStorage.getItem('token')) {
      fetchUserData()
    }
  }, [fetchUserData])
  useEffect(() => {
    window.addEventListener('storage', (event) => {
      if (
        localStorage.getItem('signin-success') === 'true' &&
        localStorage.getItem('token')
      ) {
        localStorage.removeItem('signin-success')
        fetchUserData(true)
      }
    })
    if (localStorage.getItem('errorMessage')) {
      toast.error(localStorage.getItem('errorMessage'))
      localStorage.removeItem('errorMessage')
    }
    if (localStorage.getItem('successMessage')) {
      toast.success(localStorage.getItem('successMessage'))
      localStorage.removeItem('successMessage')
    }
  }, [fetchUserData])


  return (
    <>
      <Routes>
        <Route path='/tasks' element={<Tasks />} />

        <Route element={<NavbarLayout />}>
          <Route path='/ask' element={<Ask />} />

          <Route path='/transcripts-summaries' element={<Meeting />} />
          <Route
            path='/transcripts-summaries/transcript'
            element={<Transcript />}
          />
          <Route path='/transcripts-summaries/summary' element={<Summary />} />
          <Route
            path='/transcripts-summaries/dashboard'
            element={<FunctionalDashboard />}
          />
          <Route
            path='/integration/zoom/login'
            element={<ZoomLogin />}
          />
          <Route
            path='/integration/zoom/disconnect'
            element={<ZoomDisconnectScreen />}
          />

          <Route
            path='/comments/:eventId'
            element={<VCComments />}
          />
          <Route 
            path='/company-dashboard'
            element={<CompanyDashboard />}
          />
        </Route>

        <Route path='/' element={<Welcome />} />
        <Route path='/home' element={<Home />} />
        <Route path='/confirm' element={<ReConfirm />} />
        <Route path='/signin' element={<Login />} />
        <Route path='/signin-again' element={<LoginAgain />} />
        <Route path='/signin-success' element={<LoginSuccess />} />
        <Route path='/auth' element={<Auth />} />
        <Route path='/auth/google/callback/web' element={<GoogleCallback />} />

        <Route path='/choose-function' element={<Function />} />
      </Routes>
    </>
  )
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadUser: loadUserRequest,
    },
    dispatch
  )
const mapStateToProps = (state) => ({
  user: state?.user?.data,
})

export default connect(mapStateToProps, mapDispatchToProps)(AllRoutes)
